import React, { MouseEvent, useState, useEffect, Dispatch, useRef, useCallback, useMemo } from 'react';
import { fetchGameStatus, selectGamesStatus } from '../../features/player/gameStatusSlice'
import { gameVote } from '../../features/player/gameSlice'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { fetchImages } from '../../features/injectSlice'
import { selectOrganizationsSlice } from '../../features/organizations/organizationSlice'
import { GameStatus, InjectInfo, Player, WorkingGroupVote, WorkingGroup } from '../../Classes1';
import { fetchSnippetsImages } from '../../features/scenarioSlice'
import BigCOA from './BigCOA';
import BigInject from './BigInject';
import COAVoteItem from './COAVoteItem';
import RFIVoteItem from './RFIVoteItem';
import { IGameStatus, IPlayer, IScenario, IInjectInfo, IWorkingGroup, IOrganization, IRFI, ITurnBrief, IImagePayloadItem } from '../../interfaces';
import { isEmpty, isEqual, isNil } from 'lodash';
import Modal from 'react-modal';
import { Tooltip } from 'react-tooltip'
import { useNavigate } from 'react-router-dom'
import { shortRank } from '../rankMap';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import _ from 'lodash';

import {
    Information as RfiIcon,
    Choices as CoaIcon,
    DocumentView as BriefIcon,
} from '@carbon/icons-react';

interface MainGameProps {
    gameScenario: IScenario;
    currentGameId: string;
    showGame: string;
    setShowGame: Dispatch<any>;
    games: IGameStatus[];
    intervalHandler: any;
}

interface AccordionItem {
    type: string, 
    marginTop: number, 
    orgId: string,
    orgName: string,
    count: number,
    readyCount: number
}

Modal.setAppElement('#root');

const MainGame: React.FC<MainGameProps> = ({ gameScenario, showGame, currentGameId, games, setShowGame, intervalHandler }) => {
    const [coaMenuItem, setCOAMenuItem] = useState<string>('');
    const [rfiMenuItem, setRFIMenuItem] = useState<string>('');
    const [briefMenuItem, setBriefMenuItem] = useState<string>('');
    const [currentWorkingGroupPlayers, setCurrentWorkingGroupPlayers] = useState<IPlayer[]>([]);
    const [currentMainGroupPlayers, setCurrentMainGroupPlayers] = useState<IPlayer[]>([]);
    const currentWorkingGroup: IWorkingGroup = new WorkingGroup();
    const [selectedAddPlayer, setSelectedAddPlayer] = useState<IPlayer>(new Player());
    const [selectedRemovePlayer, setSelectedRemovePlayer] = useState<IPlayer>(new Player());
    const [endGameModalIsOpen, setEndGameModalIsOpen] = useState<boolean>(false);
    const [briefingModalIsOpen, setBriefingModalIsOpen] = useState<boolean>(false);
    const [voteStateModalIsOpen, setVoteStateModalIsOpen] = useState<boolean>(false);
    const [showRightColumn, setShowRightColumn] = useState<string>('show');
    const [pendingMemberSelection, setPendingMemberSelection] = useState<boolean>(false);
    const [injectImages, setInjectImages] = useState<any[]>([]);
    const [finishedInjectImages, setFinishedInjectImages] = useState<any[]>([]);
    const [snippetImages, setSnippetImages] = useState<any[]>([]);
    const [iVoted, setIVoted] = useState<boolean>(false);
    const [voteCount, setVoteCount] = useState<number>(0);
    const [voteActionsCount, setVoteActionsCount] = useState<number>(0);
    const [voteActions2Count, setVoteActions2Count] = useState<number>(0);
    const [currentTurnStatus, setCurrentTurnStatus] = useState<string>('');
    const [accordionArray, setAccordionArray] = useState<AccordionItem[]>([]);
    const [noOrgs, setNoOrgs] = useState<IPlayer[]>([]);
    const [player, setPlayer] = useState<IPlayer>();
    const [lastBriefSeen, setLastBriefSeen] = useState<boolean>(false);

    const dispatch = useAppDispatch();
    const navigate = useNavigate()
    const user = useAppSelector((state) => state.auth.userId)

    const carouselImgsRef = useRef<NodeListOf<Element>>()

    useEffect(() => {
        if (carouselImgsRef.current === undefined) {
            carouselImgsRef.current = document.querySelectorAll('.scenario-carousel-img')
        }
        if (carouselImgsRef.current !== undefined) {
            carouselImgsRef.current = document.querySelectorAll('.scenario-carousel-img')
            if (carouselImgsRef.current!.length === gameScenario.images.length) {
                
                const onImageLoaded = (img: any) => {
                    if (img.target.height > img.target.width) {
                        img.target.style.width = 'auto';
                        img.target.style.height = '261px';
                    } else if (img.target.height < img.target.width) {
                        img.target.style.maxWidth = '392px';
                    }
                };
                for (let i = 0; i<carouselImgsRef.current.length; i++) {

                    let currImage = carouselImgsRef.current[i] as HTMLImageElement
                    
                    if (currImage) {
                        currImage.addEventListener('load', onImageLoaded);
                    }
                }
                
            }
        }
    }, [gameScenario.images.length, carouselImgsRef.current]) // eslint-disable-line react-hooks/exhaustive-deps

    let currentGameStatus: IGameStatus = useAppSelector(selectGamesStatus)[0];
    if (currentGameStatus === undefined) {
        currentGameStatus = new GameStatus();
    }

    const iVotedRFI = useMemo(() => {
        return !currentGameStatus.completed
            && currentGameStatus.moves.some((mv) =>
                mv.turn === currentGameStatus.currentTurn
                && mv.player === user
                && mv.type === 'action'
                && mv.options.choiceType === 'rfi'
                && parseInt(mv.options.injectID, 10) === currentGameStatus.currentInjectId
            );
    }, [
        currentGameStatus.completed, currentGameStatus.currentTurn,
        currentGameStatus.moves, currentGameStatus.currentInjectId, user,
    ]);

    // NOTE: Backend doens't advance the turn if it ends on a End Node for some reason.
    const lastCompletedTurn = currentGameStatus.mainGroup.moveHistory.reduce<number>((lastTurn, mv) => mv.type === 'result' ? Math.max(mv.turn, lastTurn) : lastTurn, 0);

    const [firstLoad, setFirstLoad] = useState(true);
    useEffect(() => {
        if (!isEmpty(currentGameId)) {
            dispatch(fetchGameStatus(currentGameId))
            if (firstLoad
                && (
                    !isEmpty(gameScenario.briefing)
                    || !isEmpty(gameScenario.snippets.filter((snippet: ITurnBrief) => snippet.turn === currentGameStatus.currentTurn))
                )
            ) {
                setBriefingModalIsOpen(true)
            }
            setFirstLoad(false);
        }
    }, [dispatch, currentGameId, gameScenario.briefing, firstLoad, currentGameStatus.currentTurn, gameScenario.snippets])
    
    // Setting this up to only reload images if the injects actually change...
    const [activeInjects, setActiveInjects] = useState(currentGameStatus.activeInjects);
    const [finishedInjects, setFinishedInjects] = useState(currentGameStatus.finishedInjects);
    useEffect(() => {
        if (!isEqual(activeInjects, currentGameStatus.activeInjects)) {
            setActiveInjects(currentGameStatus.activeInjects);
        }
        if (!isEqual(finishedInjects, currentGameStatus.finishedInjects)) {
            setFinishedInjects(currentGameStatus.finishedInjects);
        }
    }, [activeInjects, finishedInjects, currentGameStatus])

    useEffect(() => {
        let injImgs: any = []
        Promise.all(activeInjects.map(async (inject: IInjectInfo, i: number) => {
            let getImageResp = await dispatch(fetchImages(inject.injectId))
            if (getImageResp.meta.requestStatus === 'fulfilled') {
                injImgs.push({injectId: inject.injectId, images: getImageResp.payload, i: inject.id })
            }
        })).then(() => {
            setInjectImages(injImgs)
        })
    }, [dispatch, activeInjects,])

    useEffect(() => {
        let injImgs: any = []
        Promise.all(finishedInjects.map(async (inject: IInjectInfo, i: number) => {
            let getImageResp: any = {}
            if (inject.noCoas) {
                getImageResp = await dispatch(fetchImages(inject.injectId))
                if (getImageResp.meta.requestStatus === 'fulfilled') {
                    injImgs.push({injectId: inject.injectId, images: getImageResp.payload, i: inject.id })
                }
            }
        })).then(() => {
            setFinishedInjectImages(injImgs)
        })
    }, [dispatch, finishedInjects])

    useEffect(() => {
        let injImgs: any = []
        Promise.all(gameScenario.snippets.map(async (snippet: ITurnBrief, i: number) => {
            let getImageResp: any = {}
            getImageResp = await dispatch(fetchSnippetsImages({ scenarioId: gameScenario.id, turn: snippet.turn }))
            if (getImageResp.meta.requestStatus === 'fulfilled') {
                injImgs.push({turn: snippet.turn, images: getImageResp.payload })
            }
        })).then(() => {
            setSnippetImages(injImgs)
        })
    }, [dispatch, gameScenario])


    // TODO: This code will not work for working groups, but those are not well defined yet anyway.
    // Grab all vote results for coas and ttls so we now what states are reachable.
    const lastVotedTurn = currentGameStatus.mainGroup.moveHistory.reduce<number>((lastMv, mv) => Math.max(mv.turn, lastMv), 0);
    const lastCompletedInjects = currentGameStatus.finishedInjects.filter((inj) => {
        return inj.noCoas && inj.currentNode
            && ((inj.startTurn - 1 + inj.currentNode.turn) >= lastVotedTurn)
    });

    const [currentTurn, setCurrentTurn] = useState(currentGameStatus.currentTurn);

    useEffect(() => {
        const topOfTurnPhase = (
            currentGameStatus.currentTurnStatus !== currentTurnStatus
            || currentGameStatus.currentTurn !== currentTurn
        );

        // Transition Turn State
        if (currentGameStatus.completed) {
            setCurrentTurnStatus('')
        } else {
            if (currentTurnStatus !== currentGameStatus.currentTurnStatus) {
                setCurrentTurnStatus(currentGameStatus.currentTurnStatus);
            }
            if (currentTurn !== currentGameStatus.currentTurn) {
                setCurrentTurn(currentGameStatus.currentTurn);
            }
        }

        // If game is running...
        // Show turn briefing and vote results if...
        // It's the last turn and we haven't seen it yet.
        // it's not the first turn and we're at the top of the turn.
        if (currentGameStatus.completed) {
            if (!lastBriefSeen) {
                openVoteStateModal();
            }
        }
        else if (
            topOfTurnPhase
            && lastCompletedTurn > 0
            && ['action', 'inject'].includes(currentGameStatus.currentTurnStatus)
        ) {
            openVoteStateModal();
        }

        if (!currentGameStatus.completed) {
            // Rest vote when we enter inject and actions.
            if (currentGameStatus.currentTurn > 0 && currentTurnStatus !== '') {
                if (
                    currentGameStatus.currentTurnStatus === 'inject'
                    || (
                        !topOfTurnPhase && currentGameStatus.currentTurnStatus === 'action'
                    )
                ) {
                    setIVoted(false);
                }
            }
        }
        
        // Breakouts
        if (currentGameStatus.currentTurnStatus === 'memberSelection') {
            setCOAMenuItem('')
            setRFIMenuItem('')
            setBriefMenuItem('')
            if (currentWorkingGroupPlayers.length === 0) {
                setCurrentMainGroupPlayers(currentGameStatus.players)
            }
            currentGameStatus.mainGroup.moveHistory.forEach((move) => {
                if (move.type === 'memberSelection' && move.player === user) {
                    setPendingMemberSelection(true)
                    
                    let mgPlayers: IPlayer[] = currentGameStatus.players.filter((player) => currentGameStatus.mainGroup.playerIDs.includes(player.userID))
                    let wgPlayers: IPlayer[] = currentGameStatus.players.filter((player) => move.options.players.includes(player.userID))
                    setCurrentWorkingGroupPlayers(wgPlayers)
                    setCurrentMainGroupPlayers(mgPlayers.filter((player) => !wgPlayers.includes(player)))
                }
            });
        } else if (topOfTurnPhase && currentGameStatus.currentTurnStatus === 'inject') {
            if (currentGameStatus.mainGroup.status === 'action') {
                setCOAMenuItem('selected');
                setBriefMenuItem('selected');
                setRFIMenuItem('selected');
            } else {
                setBriefMenuItem('');
                setCOAMenuItem('')
                setRFIMenuItem('')
            }
        }  else if (topOfTurnPhase && currentGameStatus.currentTurnStatus === 'action') {
            setCOAMenuItem('selected')
            setBriefMenuItem('selected')
            setRFIMenuItem('selected');
            const activeInject = currentGameStatus.activeInjects.find((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId);
            if (activeInject) {
                setRFIMenuItem(activeInject.currentNode.rfis.length > 0 ? 'selected' : '');
                setBriefMenuItem(activeInject.currentNode.informationBriefs.length > 0 ? 'selected' : '')
                setCOAMenuItem(activeInject.currentNode.coas.length > 0 ? 'selected': '');
            }
        }

        // Decide on UI display
        if (currentGameStatus.completed === true && showGame !== '') {
            setShowRightColumn('hide')
            if (lastCompletedInjects.length === 0) {
                openEndGameModal();
            }
        } else {
            setShowRightColumn('show')
        }

        // Breakouts?
        const tempOrgs: string[] = []
        const accArray: AccordionItem[] = []
        const allOrgs: AccordionItem[] = []

        if (organizations.length > 0) {
            for (let i = 0; i<organizations.length; i++) {
                let accItem: AccordionItem = { orgId: '', orgName: '', count: 0, readyCount: 0, type: 'open', marginTop: 0 }
            
                accItem.orgId = organizations[i].id;
                accItem.orgName = organizations[i].orgName;
            
                allOrgs.push(accItem)
            }
        }

        for (let i = 0; i<currentGameStatus.players.length; i++) {
            tempOrgs.push(currentGameStatus.players[i].orgId)
        }

        for (let j = 0; j<allOrgs.length; j++) {
            let orgCount: number = 0;
            let readyCount: number = 0;
            for (let i = 0; i<currentGameStatus.players.length; i++) {
                if (currentGameStatus.players[i].orgId === allOrgs[j].orgId) {
                    orgCount++;
                    if (currentGameStatus.players[i].role !== null) {
                        readyCount++
                    }
                }
            }
            allOrgs[j].count = orgCount
            allOrgs[j].readyCount = readyCount
        }

        let uniqueOrgs = tempOrgs.filter(function (v, i, self) {

            // It returns the index of the first
            // instance of each value
            return i === self.indexOf(v);
        });

        for (let i = 0; i<uniqueOrgs.length; i++) {
            accArray.push({type: 'open', marginTop: 0, orgId: uniqueOrgs[i], orgName: '', count: 0, readyCount: 0})
        }

        for (let i = 0; i<accordionArray.length; i++) {
            if (accordionArray[i].type === 'open') {
                for (let i = 0; i<allOrgs.length; i++) {
                    if (allOrgs[i].orgId === accordionArray[i].orgId) {
                        allOrgs[i].marginTop = accordionArray[i].marginTop
                    }
                }
            } else {
                allOrgs[i].type = 'closed'
            }
        }

        let noOrgsPlayer: IPlayer[] = [];
        
        for (let q = 0; q<currentGameStatus.players.length; q++) {
            let isInOrg: boolean = false;
            for (let r = 0; r<organizations.length; r++) {
                if (currentGameStatus.players[q].orgId === organizations[r].id) {
                    isInOrg = true;
                }
            }
            if (!isInOrg) {
                let noOrgPlayer = JSON.parse(JSON.stringify(currentGameStatus.players[q]))
                noOrgsPlayer.push(noOrgPlayer) 
            }
        }

        setNoOrgs(noOrgsPlayer)
        setPlayer(noOrgsPlayer.find((p) => p.userID === user))
        setAccordionArray(allOrgs)

    }, [currentGameStatus.currentInjectId, currentGameStatus.currentTurnStatus, currentGameStatus.completed, currentGameStatus.currentTurn, lastBriefSeen, lastCompletedTurn]) // eslint-disable-line react-hooks/exhaustive-deps
    // NOTE: This will likely need to be re-evaluated as we incorporate working groups, we should consider breaking working group code into another effect.

    useEffect(() => {
        let votesCount: number = 0;

        for (let j = 0; j<currentGameStatus.activeInjects.length; j++) {
            for (let i = 0; i<currentGameStatus.moves.length; i++) {
                if (currentGameStatus.moves[i].type === 'inject' && parseInt(currentGameStatus.moves[i].choice, 10) === currentGameStatus.activeInjects[j].id && currentGameStatus.currentTurn === currentGameStatus.moves[i].turn) {
                    votesCount++;
                }
            }
        }

        setVoteCount(votesCount)

        let votesActionsCount: number = 0;

        for (let i = 0; i<currentGameStatus.moves.length; i++) {
            if (currentGameStatus.moves[i].type === 'groupFormation' && currentGameStatus.moves[i].options?.choiceType === 'coa' && currentGameStatus.currentTurn === currentGameStatus.moves[i].turn) {
                if (currentGameStatus.moves[i].player === user && currentGameStatus.currentTurnStatus === 'groupFormation') {
                    //setIVoted(true)
                }
                votesActionsCount++;
            }
        }

        for (let i = 0; i<currentGameStatus.moves.length; i++) {
            if (currentGameStatus.moves[i].type === 'groupFormation' && currentGameStatus.moves[i].options?.choiceType === 'workingGroup' && currentGameStatus.currentTurn === currentGameStatus.moves[i].turn) {
                if (currentGameStatus.moves[i].player === user && currentGameStatus.currentTurnStatus === 'groupFormation') {
                    //setIVoted(true)
                }
                votesActionsCount++;
            }
        }

        setVoteActionsCount(votesActionsCount)

        let votesActions2Count: number = 0;

        for (let i = 0; i<currentGameStatus.moves.length; i++) {
            if (currentGameStatus.moves[i].type === 'action' && currentGameStatus.moves[i].options.choiceType === 'coa' && currentGameStatus.currentTurn === currentGameStatus.moves[i].turn) {
                if (currentGameStatus.moves[i].player === user && currentGameStatus.currentTurnStatus === 'action') {
                    //setIVoted('already-voted')
                }
                votesActions2Count++;
            }
        }

        for (let i = 0; i<currentGameStatus.moves.length; i++) {
            if (currentGameStatus.moves[i].type === 'action' && currentGameStatus.moves[i].options.choiceType === 'rfi' && currentGameStatus.currentTurn === currentGameStatus.moves[i].turn) {
                if (currentGameStatus.moves[i].player === user && currentGameStatus.currentTurnStatus === 'action') {
                    //setIVoted('already-voted')
                }
                votesActions2Count++;
            }
        }

        setVoteActions2Count(votesActions2Count)
    }, [currentGameStatus]) // eslint-disable-line react-hooks/exhaustive-deps

    let organizations: IOrganization[] = useAppSelector(selectOrganizationsSlice);
    if (organizations === undefined) {
        organizations = [];
    }

    const organizationsRef = useRef<any>()
    useEffect(() => {
        organizationsRef.current = organizations
    });

    const openEndGameModal = () => {
        setEndGameModalIsOpen(true);
    }

    const closeEndGameModal = () => {
        setEndGameModalIsOpen(false);
    }

    const closeBriefingModal = () => {
        setBriefingModalIsOpen(false);
    }

    const openVoteStateModal = () => {
        setVoteStateModalIsOpen(true);
    }

    const closeVoteStateModal = () => {
        setVoteStateModalIsOpen(false);
    }

    const returnToMain = (ev: MouseEvent) => {
        setShowGame('')
        closeEndGameModal();
    }

    const submitWorkingGroup = async (ev: MouseEvent) => {
        let gameVoteObj: any = {};
        gameVoteObj.gameId = currentGameStatus.gameId;
        gameVoteObj.voteObj = {};

        let wgIds: string[] = [];

        currentWorkingGroupPlayers.forEach((player) => {
            wgIds.push(player.userID)
        })

        let newVote = new WorkingGroupVote();
        newVote.type = 'memberSelection';
        newVote.choice = '';
        newVote.reason = '';
        newVote.workingGroupOptions = {
            injectId: currentGameStatus.mainGroup.injectId.toString(),
            players: wgIds
        }

        gameVoteObj.voteObj = newVote;

        let gameVoteResponse: any = await dispatch(gameVote(gameVoteObj))
        await dispatch(fetchGameStatus(currentGameStatus.gameId));

        if (gameVoteResponse.error !== undefined) {
            console.log("Vote Rejected!")
        }
    }

    const selectPlayer = (ev: MouseEvent) => {
        ev.stopPropagation();
        
        const target = ev.currentTarget as HTMLElement;

        if (target) {
            currentGameStatus.players.forEach((player: IPlayer, i: number) => {
                if (player.userID === target.dataset.id && target.classList.contains('selected') && target.dataset.addremove === 'add') {
                    setSelectedAddPlayer(new Player());
                }
                if (player.userID === target.dataset.id && !target.classList.contains('selected') && target.dataset.addremove === 'add' && !target.classList.contains('disabled')) {
                    setSelectedAddPlayer(player);
                }

                if (player.userID === target.dataset.id && target.classList.contains('selected') && target.dataset.addremove === 'remove') {
                    setSelectedRemovePlayer(new Player());
                }
                if (player.userID === target.dataset.id && !target.classList.contains('selected') && target.dataset.addremove === 'remove' && !target.classList.contains('disabled')) {
                    setSelectedRemovePlayer(player);
                }
            })
        }
    }

    const addPlayerToWG = (ev: MouseEvent) => {
        ev.stopPropagation();
        if (!(ev.currentTarget instanceof HTMLElement)) {
            return;
        }

        const target = ev.currentTarget as HTMLElement;

        if (target) {
            currentGameStatus.players.forEach((player: IPlayer, i: number) => {
                if (player.userID === selectedAddPlayer.userID) {
                    setCurrentWorkingGroupPlayers([
                        ...currentWorkingGroupPlayers, player
                    ]);
                    setCurrentMainGroupPlayers(currentMainGroupPlayers.filter((mgPlayer) => mgPlayer.userID !== player.userID))
                    setSelectedAddPlayer(new Player())
                }
            })
        }
    }

    const removePlayerFromWG = (ev: MouseEvent) => {
        ev.stopPropagation();
        if (!(ev.currentTarget instanceof HTMLElement)) {
            return;
        }

        const target = ev.currentTarget as HTMLElement;

        if (target) {
            currentGameStatus.players.forEach((player: IPlayer, i: number) => {
                if (player.userID === selectedRemovePlayer.userID) {
                    setCurrentMainGroupPlayers([
                        ...currentMainGroupPlayers, player
                    ]);
                    setCurrentWorkingGroupPlayers(currentWorkingGroupPlayers.filter((mgPlayer) => mgPlayer.userID !== player.userID))
                    setSelectedRemovePlayer(new Player())
                }
            })
        }
    }

    const selectLeftNav = (ev: MouseEvent) => {
        if (!(ev.currentTarget instanceof HTMLElement)) {
            return;
        }

        const target = ev.currentTarget as HTMLElement;
        
        if (target) {
            updateNav(ev.currentTarget.dataset.id);
        }
    }

    const updateNav = (navName: string | undefined) => {
        switch(navName)
        {
            case 'injects':
                const activeInject = currentGameStatus.activeInjects.find((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId);
                setCOAMenuItem('selected');
                setRFIMenuItem('selected');
                setBriefMenuItem('selected');
                if (activeInject) {
                    setRFIMenuItem(activeInject.currentNode.rfis.length > 0 ? 'selected' : '');
                    setBriefMenuItem(activeInject.currentNode.informationBriefs.length > 0 ? 'selected' : '')
                    setCOAMenuItem(activeInject.currentNode.coas.length > 0 ? 'selected': '');
                }
                break;
            case 'inject-brief':
                setCOAMenuItem('');
                setRFIMenuItem('');
                setBriefMenuItem('selected');
                break;
            case 'inject-coas':
                setCOAMenuItem('selected');
                setRFIMenuItem('');
                setBriefMenuItem('');
                break;
            case 'inject-rfi':
                setCOAMenuItem('');
                setRFIMenuItem('selected');
                setBriefMenuItem('');
                break;
            case 'nodes':
                setBriefingModalIsOpen(true)
            break;
        }
    }

    const groupIconSwitch = (value: string) => {
        switch(value) {
            case 'inject':
                return <div className="select-inject-text">Selecting an Inject</div>
            case 'action':
                return <div className="select-inject-text">Selecting an Action</div>
            case 'groupFormation':
                return <div className="select-inject-text">Selecting An Action</div>
            case 'memberSelection':
                return <div className="select-inject-text">Forming A Working Group</div>   
            default:
              break;
          }
    }

    const groupStatus = (group: string) => {
        if (group === 'main') {
            
            let inMG: boolean = false;
            for (let i = 0; i<currentGameStatus.mainGroup.playerIDs.length; i++) {
                if (user === currentGameStatus.mainGroup.playerIDs[i] && currentGameStatus.mainGroup.status !== 'result') {
                    inMG = true;
                }
            }

            if (inMG) {
                return 'selected'
            } else {
                return ''
            }
        }
        

        if (group === 'workinggroup') {
            
            let inWG: boolean = false;
            for (let j = 0; j<currentWorkingGroup.playerIDs.length; j++) {
                if (user === currentWorkingGroup.playerIDs[j]) {
                    inWG = true;
                }
            }

            if (inWG) {
                return 'selected'
            } else {
                return ''
            }
        }
    }

    const getVoteWinner = useCallback(() => {
        const moves = currentGameStatus.mainGroup.moveHistory;
        const lastMove = moves ? moves[moves.length - 1] : undefined;
        if (currentGameStatus.currentTurnStatus === 'inject' || currentGameStatus.currentTurnStatus === 'result') {
            if (lastMove?.type === 'result' && lastMove?.options.choiceType === 'coa') {
                return <div className="winning-vote-item">
                    <div className="winning-inject-title">
                        The winning inject is <span>{currentGameStatus.lastWinner.injectName}</span>&nbsp;
                        and the winning COA is <span>{currentGameStatus.lastWinner.coaName}</span>.
                        {!currentGameStatus.completed &&
                        <>The next step is to vote on Injects in <b>Turn {currentGameStatus.currentTurn}.</b></>
                        }
                    </div>
                </div>
            }
        }

        if (currentGameStatus.currentTurnStatus === 'groupFormation') {
            let injectName = '';
            if (currentGameStatus.activeInjects[currentGameStatus.mainGroup.injectId] !== undefined) {
                injectName = currentGameStatus.activeInjects[currentGameStatus.mainGroup.injectId].name
            }
            return <div className="winning-vote-item">
                    <div className="winning-inject-title">Winning Inject</div>
                    <div className="winning-inject">{injectName}</div>
                </div>
        }

        if (currentGameStatus.currentTurnStatus === 'action') {
            return <div className="winning-vote-item">
                <div className="winning-inject-title">
                    The winning inject is <span>{currentGameStatus.lastWinner.injectName}</span>&nbsp;
                    and the next step is to vote on actions in <b>Turn {currentGameStatus.currentTurn}.</b>
                </div>
            </div>
        }
    }, [currentGameStatus.currentTurnStatus, currentGameStatus.currentTurn,
        currentGameStatus.mainGroup.moveHistory, currentGameStatus.mainGroup.injectId,
        currentGameStatus.lastWinner, currentGameStatus.activeInjects, currentGameStatus.completed]);

    const clickVotingContinue = () => {
        closeVoteStateModal()
        if (currentGameStatus.completed) {
            setLastBriefSeen(true);
        }
    }
    useEffect(() => {
        if (currentGameId !== currentGameStatus.gameId) {
            setLastBriefSeen(false);
        }
    }, [currentGameStatus.gameId, currentGameId])

    const clickOrgRow = (ev: MouseEvent) => {
        const target = ev.currentTarget as HTMLElement;
        
        if (target) {
            
            let rowHeight = 0;
            for (let i = 0; i<currentGameStatus.players.length; i++) {
                if (currentGameStatus.players[i].orgId === target.dataset.rowid) {
                    rowHeight += 64;
                }
            }

            let accArray = JSON.parse(JSON.stringify(accordionArray))
            
            for (let i = 0; i<accordionArray.length; i++) {
                if (accordionArray[i].orgId === target.dataset.rowid) {
                    if (accArray[i].type === 'open') {
                        accArray[i].type = 'close'
                        accArray[i].marginTop = -rowHeight
                    } else {
                        accArray[i].type = 'open'
                        accArray[i].marginTop = 0
                    }
                }
            }
            
            setAccordionArray(accArray)
        }
    }

    const currentNodeHasRFI = () => {
        if (currentGameStatus.currentInjectId !== -1 && currentGameStatus.currentInjectId !== null && currentGameStatus.activeInjects.length > 0) {
            if  (currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode === null) { 
                return <></>;
            } else { 
                if (currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode.rfis.length > 0) {
                    return <div onClick={selectLeftNav} className={`carbon-icon ${rfiMenuItem}`} data-id="inject-rfi" aria-label="Request For Information" data-tooltip-place="top" data-tooltip-content="Request For Information" data-tooltip-id="tooltip-rfi"><RfiIcon size="24"/></div>;
                } else {
                    return <></>;
                }
            }
        }
    }

    //console.log("currentGameStatus.currentTurn: ", currentGameStatus.currentTurn)
    const turnImages = snippetImages.find((si) => si.turn === currentGameStatus.currentTurn);
    const turnSnippet = gameScenario.snippets.find((snippet: ITurnBrief) => snippet.turn === currentGameStatus.currentTurn)

    return (
        <div className={`main-game ${showGame}`}>
            <div className="game-left-nav">
                <div className={`list-find-icon selected`} onClick={selectLeftNav} data-id="injects" aria-label="Inject" data-tooltip-place="top" data-tooltip-content="Injects" data-tooltip-id="tooltip-inject" ><img src="img/list-find.svg" alt="icon" /></div>
                {
                    (currentGameStatus.currentTurnStatus === 'action') &&
                    <>
                    <div onClick={selectLeftNav} className={`carbon-icon ${briefMenuItem}`} data-id="inject-brief" aria-label="Information Briefs" data-tooltip-place="top" data-tooltip-content="Information Briefs" data-tooltip-id="tooltip-info"><BriefIcon size="24"/></div>
                    { currentNodeHasRFI() }
                    <div onClick={selectLeftNav} className={`carbon-icon ${coaMenuItem}`} data-id="inject-coas" aria-label="Courses Of Action" data-tooltip-place="top" data-tooltip-content="Courses Of Action" data-tooltip-id="tooltip-coa"><CoaIcon size="24"/></div>
                    </>
                }
                <div className={`question-doc-icon`} onClick={selectLeftNav} data-id="nodes" aria-label="Briefing" data-tooltip-place="top" data-tooltip-content="Briefing" data-tooltip-id="tooltip-briefs"><img src="img/question-doc.svg" alt="icon" /></div>
            </div>
            {/* 
            <div className={`inject-list ${currentGameStatus.currentTurnStatus === 'inject' || currentGameStatus.currentTurnStatus === 'groupFormation' ? 'selected' : '' }`}>
                {currentGameStatus.activeInjects.map((inj: IInjectInfo, i: number) => {
                    return (
                        <div className={`inject-list-item`} data-id={inj.injectId} key={i}>
                            <div className="item-title">{inj.name}</div>
                        </div>
                    )
                })}
            </div>
            */}
            <div className={`inject-list ${currentGameStatus.currentTurnStatus === 'memberSelection' ? 'selected' : '' }`}>
                {currentGameStatus.activeInjects.map((inj: IInjectInfo, i: number) => {
                    return (
                        <div key={i}></div>
                    )
                })}
            </div>
            <div className="game-content">
                <div className={`game-inject-detail ${currentGameStatus.workingGroups.length > 0 ? currentWorkingGroup.status : currentGameStatus.currentTurnStatus}-player`}>
                    <div className={`game-inject-detail-header ${currentGameStatus.workingGroups.length > 0 ? currentWorkingGroup.status : currentGameStatus.currentTurnStatus}-player`}>
                        
                        {process.env.REACT_APP_IMAGE_SRC === 'local' ? 
                            currentGameStatus.activeInjects.filter((injInfo, i) => i === currentGameStatus.currentInjectId)[0] !== undefined ?
                                <img src={!isEmpty(currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].localImage) ? 'data:image/png;base64, ' + currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].localImage : 'img/inject-detail.png' } className="game-inject-image" alt="" /> : <img src='img/inject-detail.png' className="game-inject-image" alt="" /> : injectImages.filter(inj => inj.i === currentGameStatus.currentInjectId)[0] !== undefined ? !isEmpty(injectImages.filter(inj => inj.i === currentGameStatus.currentInjectId)[0].images.url) ? <img src={injectImages.filter(inj => inj.i === currentGameStatus.currentInjectId)[0].images.url} className="game-inject-image" alt="" /> : <img src='img/inject-detail.png' className="game-inject-image" alt="" /> : <img src='img/loading-816x216.gif' className="game-inject-image" alt="" />}

                        <div className="game-inject-content">
                            <div className="game-inject-title">{currentGameStatus.workingGroups.length === 0 ? currentGameStatus.currentInjectId !== -1 && currentGameStatus.currentInjectId !== null && currentGameStatus.activeInjects.length > 0 ? currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].name : 'Temp Inject' : currentWorkingGroup.injectId !== null ? currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentWorkingGroup.injectId)[0].name : ''}</div>
                            <div className="game-inject-text">
                                {/* NOTE: Restore this when we bring back working groups.
                                <img src="img/blue-team.svg" className="game-inject-text-icon" alt="" />
                                <div className="game-inject-text-label">{currentGameStatus.workingGroups.length>0 ? 'Working Group' : 'Main Group'}</div>
                                */}
                                <div className="game-inject-text-label">Turn {currentGameStatus.currentTurn}</div>
                            </div>
                        </div>
                        <div className="game-inject-content-text">
                            {currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0] === undefined ? '' : currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode === null ? '' : currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode.description}
                        </div>
                    </div>

                {currentGameStatus.currentTurnStatus === 'action' &&
                <>
                    <div className={`game-inject-coa-content ${briefMenuItem}`}>
                        <div className="game-coa-title">
                            INFORMATION BRIEFS
                        </div>
                        <div className="game-coa-items" style={{color: 'white'}}>
                            {
                                !isNil(currentGameStatus.currentInjectId)
                                && (currentGameStatus.currentInjectId !== -1)
                                && !isEmpty(currentGameStatus.activeInjects)
                                && currentGameStatus.activeInjects.filter((i) => i.id === currentGameStatus.currentInjectId)
                                && currentGameStatus.activeInjects.filter((i) => i.id === currentGameStatus.currentInjectId).length > 0
                                && currentGameStatus.activeInjects.filter((i) => i.id === currentGameStatus.currentInjectId)[0].currentNode.informationBriefs.length > 0
                                ?<ul>{currentGameStatus.activeInjects.find((i) => i.id === currentGameStatus.currentInjectId)?.currentNode.informationBriefs.filter(
                                    (b) => b.role === '' || b.role === player?.role
                                ).map((b, idx) => 
                                    <li className="brief-text" key={`${b.role}-${idx}`}>
                                        {b.displayText}
                                    </li>
                                )}</ul>
                                : <div className="brief-text">No briefs available for this inject</div>
                            }
                        </div>
                    </div>

                    <div className={`game-inject-coa-content ${rfiMenuItem}`}>
                        <div className="game-coa-title">
                            REQUEST FOR INFORMATION
                        </div>
                        <div className="game-coa-subtitle">
                            RFI Questions currently available are listed below. Please select one question to submit to command.
                        </div>

                        <div className="game-coa-items">
                            
                        {currentGameStatus.workingGroups.length === 0 ? 
                        
                        (currentGameStatus.currentInjectId !== -1 && currentGameStatus.currentInjectId !== null && currentGameStatus.activeInjects.length > 0 ? currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode === null ? <></> : currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode.rfis.map((rfi: IRFI, j: number) => {
                                    return (
                                        <div className="rfi-item-qs-and-as" key={rfi.id}>
                                            <RFIVoteItem currentGameStatus={currentGameStatus} rfi={rfi} intervalHandler={intervalHandler} iVotedRFI={iVotedRFI} key={rfi.id} />
                                        </div>
                                    )
                                }) : <></>) : currentWorkingGroup.injectId !== null ? currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentWorkingGroup.injectId)[0].currentNode.rfis.map((rfi: IRFI, j: number) => {
                                    return (
                                        <div className="rfi-item-qs-and-as" key={rfi.id}>
                                            <RFIVoteItem currentGameStatus={currentGameStatus} rfi={rfi} intervalHandler={intervalHandler} iVotedRFI={iVotedRFI} key={rfi.id } />
                                        </div>
                                    )
                                }) : <></>}
                        </div>
                    </div>

                    <div className={`game-inject-coa-content ${coaMenuItem}`}>
                        <div className="game-coa-title">
                            COURSE OF ACTION
                        </div>

                        {currentGameStatus.currentInjectId !== -1 && currentGameStatus.currentInjectId !== null && currentGameStatus.activeInjects.length > 0 ? currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode === null ? <></> : currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode.coas.length === 0 ? 
                                <div className="game-coa-subtitle">No Courses of Action to vote for</div> : <div className="game-coa-subtitle">
                                Vote for a Course of Action
                            </div> : <></> }

                        {currentGameStatus.currentInjectId !== -1 && currentGameStatus.currentInjectId !== null && currentGameStatus.activeInjects.length > 0 ? currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode === null ? <></> : currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode.coas.length === 0 ? 
                                <></> : <div className="game-injects-vote-results actions2-votes">
                        {voteActions2Count}/{currentGameStatus.players.length} of Votes Cast</div> : <></> }

                        <div className="game-coa-items">
                            
                        {currentGameStatus.workingGroups.length === 0 ? 
                        
                        (currentGameStatus.currentInjectId !== -1 && currentGameStatus.currentInjectId !== null && currentGameStatus.activeInjects.length > 0 ? currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode === null ? <></> : currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode.coas.map((coa: any, j: number) => {
                                    return (
                                        <COAVoteItem currentGameStatus={currentGameStatus} currentId={coa.id} coa={coa} currentInjectId={currentGameStatus.currentInjectId} injectImages={injectImages} intervalHandler={intervalHandler} iVoted={iVoted} setIVoted={setIVoted} key={j} />
                                    )
                                }) : <></>) : currentWorkingGroup.injectId !== null ? currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode === null ? <></> : currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentWorkingGroup.injectId)[0].currentNode.coas.map((coa: any, j: number) => {
                                    return (
                                        <COAVoteItem currentGameStatus={currentGameStatus} currentId={coa.id} coa={coa} currentInjectId={currentGameStatus.currentInjectId} injectImages={injectImages} intervalHandler={intervalHandler} iVoted={iVoted} setIVoted={setIVoted} key={j} />
                                    )
                                }) : <></>}

                        {currentGameStatus.currentInjectId !== -1 && currentGameStatus.currentInjectId !== null && currentGameStatus.activeInjects.length > 0 ? currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode === null ? <></> : currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode.coas.length === 0 ? 
                        <div className="game-vote-item no-coas">
                            {/*<div className="game-vote-item-title">
                                {currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode.description}
                            </div>*/}
                            <div className="game-vote-item-details">
                                <div className="game-vote-item-text">
                                    {currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].currentNode.description}
                                </div>
                                <div className="game-vote-item-votes">
                                    
                                </div>
                            </div>
                        </div> : <div></div> : <div></div> }
                    
                        </div>
                    </div>

                </>}
                </div>

                <div className={`game-actions ${currentGameStatus.currentTurnStatus === 'groupFormation' ? 'show' : 'hide' }`}>
                        <div className="game-action-title">
                            ACTIONS
                        </div>
                        <div className="game-action-subtitle">
                            Vote for an action to perform on this inject
                        </div>

                        <div className="game-injects-vote-results actions-votes">
                        {voteActionsCount}/{currentGameStatus.players.length} of Votes Cast</div>
                        
                        <BigCOA currentGameStatus={currentGameStatus} injectImages={injectImages} inject={currentGameStatus.currentInjectId !== -1 && currentGameStatus.currentInjectId !== null && currentGameStatus.activeInjects.length > 0 ? currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0] : new InjectInfo()} intervalHandler={intervalHandler} currentInjectId={currentGameStatus.currentInjectId} iVoted={iVoted} setIVoted={setIVoted} key={1} />
                            
                        {/*<div className="game-vote-item" data-item="workinggroup">
                            <div className="game-vote-item-title">
                                Form A Working Group
                            </div>
                            <div className="game-vote-item-details">
                                <div className="game-vote-item-text">
                                    Select 2 or more team members to form a working group to address this inject. Frees up the remaining team members to perform other tasks. 
                                </div>
                                <div className="game-vote-item-votes">
                                    <GameVotes iVoted={iVoted} setIVoted={setIVoted} intervalHandler={intervalHandler} voteType="groupFormation-workingGroup" currentGameStatus={currentGameStatus} currentId={1} currentInjectId={currentGameStatus.currentInjectId} inject={currentGameStatus.currentInjectId !== -1 && currentGameStatus.currentInjectId !== null && currentGameStatus.activeInjects.length > 0 ? currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0] : new InjectInfo()}  setShowGame={setShowGame} />
                                </div>
                            </div>
                        </div>*/}
                    </div>
                
                <div className={`game-member-selection ${currentGameStatus.currentTurnStatus === 'memberSelection' ? 'show' : 'hide' }`}>
                    <div className="game-action-title">
                        Form A Working Group
                    </div>
                    <div className="game-action-subtitle">
                        Select two or more team members to form Working Group Alpha. This Working group is tasked with addressing and resolving Inject: Tern 32.
                    </div>
                    <div className="wg-content">
                        <div className="wg-select-members">
                            <div className="wg-select-title">Team Members</div>
                            <div className="wg-select-member-box">
                                {currentMainGroupPlayers.map((player, i) => {
                                    return <div className={`wg-select-member ${selectedAddPlayer.userID === player.userID ? 'selected' : ''} ${pendingMemberSelection ? 'disabled' : ''}`} onClick={selectPlayer} data-id={player.userID} data-addremove="add" key={i}>
                                        <div className="wg-select-member-rank">{shortRank(player.rank)}</div>
                                        <div className="wg-select-member-lastname">{player.lastName}</div>
                                    </div>
                                })}
                            </div>
                        </div>
                        <div className="wg-select-arrows">
                            <div className={`wg-select-left-arrow ${selectedAddPlayer.userID !== '' ? 'selected' : ''}`} onClick={addPlayerToWG}>
                                <img src="img/chevron-right.svg" alt="" />
                            </div>
                            <div className={`wg-select-right-arrow ${selectedRemovePlayer.userID !== '' ? 'selected' : ''}`} onClick={removePlayerFromWG}>
                                <img src="img/chevron-right.svg" alt="" />
                            </div>
                        </div>
                        <div className="wg-members-selected">
                            <div className="wg-select-title">Working Group Alpha <span>1/2</span></div>
                            <div className="wg-select-member-box">
                                {currentWorkingGroupPlayers.map((player, i) => {
                                    return <div className={`wg-select-member ${selectedRemovePlayer.userID === player.userID ? 'selected' : ''} ${pendingMemberSelection ? 'disabled' : ''}`} onClick={selectPlayer} data-addremove="remove" data-id={player.userID} key={i}>
                                        <div className="wg-select-member-rank">{shortRank(player.rank)}</div>
                                        <div className="wg-select-member-lastname">{player.lastName}</div>
                                    </div>
                                })}
                            </div>
                        </div>
                        {pendingMemberSelection ? <button className="select-working-group-btn member-voted">Awaiting Member Selection Completion...</button> : <button className="select-working-group-btn" onClick={submitWorkingGroup}>FORM WORKING GROUP ALPHA AND ASSIGN TO {currentGameStatus.workingGroups.length === 0 ? currentGameStatus.currentInjectId !== -1 && currentGameStatus.currentInjectId !== null && currentGameStatus.activeInjects.length > 0 ? currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentGameStatus.currentInjectId)[0].name : 'Temp Inject' : currentWorkingGroup.injectId !== null ? currentGameStatus.activeInjects.filter((injInfo, i) => injInfo.id === currentWorkingGroup.injectId)[0].name : ''} </button> }
                        
                    </div>
                </div>

                <div className={`game-injects-main ${(currentGameStatus.currentTurnStatus === 'inject' || (currentGameStatus.completed && currentGameStatus.currentTurnStatus === 'result')) ? 'selected' : ''}`}>
                    <div className="game-injects-title">
                        Injects
                    </div>
                    {lastCompletedInjects.length > 0 && <>
                    <div className="game-injects-subtile-content">
                        <div className="game-injects-subtitle">Inject Results</div>
                        {
                        currentGameStatus.completed &&
                        <button className="txp-sc-exit" onClick={openEndGameModal} style={{textAlign: 'center', top: '-60px', right: 0}}>End Scenario</button>
                        }
                    </div>
                    <div className="big-injects" style={{marginBottom: '3em'}}>
                        {lastCompletedInjects.map((inject: IInjectInfo, i: number) => {
                            return (
                                <BigInject currentGameStatus={currentGameStatus} injectImages={injectImages} inject={inject} index={i} noCoas={true} intervalHandler={intervalHandler} iVoted={iVoted} setIVoted={setIVoted} finishedInjectImages={finishedInjectImages} setCurrentTurnStatus={setCurrentTurnStatus} key={inject.id} />
                            )
                        })}
                    </div>
                    </>}

                    { currentGameStatus.activeInjects.length > 0 && <>
                    <div className="game-injects-subtile-content">
                        <div className="game-injects-subtitle">
                            Vote for an inject to address this turn
                        </div>
                        <div className="game-injects-vote-results">
                        {voteCount}/{currentGameStatus.players.length} of Votes Cast</div>
                    </div>
                    <div className="big-injects">
                    {currentGameStatus.activeInjects.map((inject: any, i: number) =>
                        <BigInject currentGameStatus={currentGameStatus} injectImages={injectImages} inject={inject} index={i} noCoas={false} intervalHandler={intervalHandler} iVoted={iVoted} setIVoted={setIVoted} finishedInjectImages={finishedInjectImages} key={inject.id} setCurrentTurnStatus={setCurrentTurnStatus} />
                    )}
                    </div>
                    <div className="voting-instructions">Select an inject to vote for it.</div>
                    </>}
                </div>
            </div>
            <div className={`game-right-column ${showRightColumn}`}>
                <div className="big-turn">
                    <div className="big-turn-label">Turn</div>
                    <div className="big-turn-data">{currentGameStatus.currentTurn}</div>
                </div>
                <div className={`right-nav-main-group ${groupStatus('main')}`}>
                    <div className="main-game-label">
                        <img src="img/team.svg" alt="" />
                        <div className="working-group-right-main-name">Main Team</div>
                    </div>
                    <div className="select-inject">
                        <div className="select-inject-label">Turn {currentGameStatus.currentTurn}.0</div>
                        {groupIconSwitch(currentGameStatus.mainGroup.status)}
                    </div>
                    <div className="team-members">
                    { noOrgs.length > 0 ? noOrgs.map((player: IPlayer, i: number) => {
                        return (
                            <div className="team-member-wrapper" key={i}>
                                <div className={`team-member ${player.ready ? 'selected' : ''}`}>
                                    <div className="team-member-title-v2">
                                        {shortRank(player.rank)}
                                    </div>
                                    <div className="team-member-name-v2">
                                        {player.lastName}
                                    </div>
                                    <div className="team-member-role-v2">
                                        {player.role}
                                    </div>
                                </div>
                            </div>
                        )
                    }) : <></> }
                    {accordionArray.map((accItem, i) => {
                            if (accItem.count > 0) {
                                let orgPlayers = currentGameStatus.mainGroup.playerIDs.map((playerID: string, i: number) => {
                                    let player = currentGameStatus.players.filter((player) => player.userID === playerID)[0]
                                    if (accItem.orgId === player.orgId) {
                                        return (
                                            <div className="team-member-wrapper">
                                                <div className={`team-member ${player.ready ? 'selected' : ''}`} key={i}>
                                                    <div className="team-member-title-v2">
                                                        {shortRank(player.rank)}
                                                    </div>
                                                    <div className="team-member-name-v2">
                                                        {player.lastName}
                                                    </div>
                                                    <div className="team-member-role-v2">
                                                        {player.role}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    } else {
                                        return (<></>)
                                    }
                                })

                                return (
                                    <>
                                        <div className={`game-org ${accItem.type}`} onClick={clickOrgRow}  data-rowid={accItem.orgId} key={i}>
                                            <div className="game-org-text">{accItem.orgName} ({accItem.count})</div>
                                            <img className="org-row-chevron" src="img/light-grey-chevron.svg" alt="chevron"></img>
                                        </div>
                                        <div className="org-players-content" style={{ marginTop: accItem.marginTop + 'px', zIndex: '10' + (99 - i) }}>
                                            {orgPlayers}
                                        </div>
                                    </>
                                )
                            } else {
                                return (<></>)
                            }
                        })}
                    </div>
                </div>
                {currentGameStatus.workingGroups.length > 0 ? 
                <div className={`right-nav-working-group ${groupStatus('workinggroup')}`}>
                    <div className="main-game-label">
                        <img src="img/team.svg" alt="" />
                        <div className="working-group-labels">
                            <div className="working-group-right-label">Working Group</div>
                            <div className="working-group-right-name">{currentWorkingGroup.name}</div>
                        </div>
                    </div>
                    <div className="select-inject">
                        <div className="select-inject-label">Turn {currentGameStatus.currentTurn}.0</div>
                        {groupIconSwitch(currentWorkingGroup.status)}
                    </div>
                    <div className="team-members">
                    {currentWorkingGroup.playerIDs.map((playerID: string, i: number) => {
                            let player = currentGameStatus.players.filter((player) => player.userID === playerID)[0]
                            return (
                                <div className={`team-member ${player.ready ? 'selected' : ''}`} key={i}>
                                    <div className="team-member-title">
                                        {shortRank(player.rank)}
                                    </div>
                                    <div className="team-member-name">
                                        {player.lastName}
                                    </div>
                                    <div className="team-member-role">
                                        {player.role}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div> : <></> }
            </div>

            {endGameModalIsOpen &&
            <Modal
                isOpen={endGameModalIsOpen}
                onRequestClose={closeEndGameModal}
                style={customStyles}
                shouldCloseOnOverlayClick={false}
                contentLabel="Game Over Modal"
            >
                <div className="game-over-message">The scenario is over.  Thanks for playing.</div>

                <button onClick={returnToMain} className="delete-cancel-btn">Go to Scenarios</button>
                <button className="delete-confirm-btn" onClick={() => navigate('/hotwash?gameid=' + currentGameId)}>Check out Hotwash</button>
            </Modal>
            }

            {voteStateModalIsOpen &&
            <Modal
                isOpen={voteStateModalIsOpen}
                onRequestClose={closeVoteStateModal}
                style={customVotingStyles}
                shouldCloseOnOverlayClick={false}
                className="turn-voting-modal"
                contentLabel="Vote State Modal"
            >
                {lastCompletedTurn > 0 && ['inject', 'action', 'result'].includes(currentGameStatus.currentTurnStatus) &&
                    <>
                    <div className="game-over-message">Voting Results</div>
                    {getVoteWinner()}
                    </>
                }

                {currentGameStatus.currentTurnStatus === 'inject' && !isEmpty(turnSnippet?.briefingText) ? 
                    <div className="briefing-modal-content">
                        <div className="briefing-modal-content-title">Turn {currentGameStatus.currentTurn} Briefing</div>
                        <div className="briefing-voting-modal-text">{turnSnippet?.briefingText}</div>
                        {!_.isEmpty(turnImages) && !_.isEmpty(turnImages.images) &&
                        <div className="briefing-images">
                            <div className="snippet-carousel">
                                <Carousel showThumbs={true}>
                                    {turnImages.images.map((image: IImagePayloadItem, idx: number) => (
                                        <img
                                            src={image.url !== '' ? image.url : "img/scenario1.png"}
                                            alt={`Briefing ${idx}`}
                                            className="scenario-carousel-img"
                                            key={image.fileName}
                                            onError={addDefaultSrc}
                                        />
                                    ))}
                                </Carousel>
                            </div>
                        </div>
                        }
                    </div> : (currentGameStatus.completed && currentGameStatus.currentTurnStatus === 'result' && !isEmpty(turnSnippet?.briefingText)) &&
                <div className="briefing-modal-content">
                    <div className="briefing-modal-content-title">Turn {currentGameStatus.currentTurn + 1} Briefing</div>
                    <div className="briefing-voting-modal-text">{turnSnippet?.briefingText}</div>
                    {!_.isEmpty(turnImages) && !_.isEmpty(turnImages.images) &&
                        <div className="briefing-images">
                            <div className="snippet-carousel">
                                <Carousel showThumbs={true}>
                                    {turnImages.images.map((image: IImagePayloadItem, idx: number) => (
                                        <img
                                            src={image.url !== '' ? image.url : "img/scenario1.png"}
                                            alt={`Briefing ${idx}`}
                                            className="scenario-carousel-img"
                                            key={image.fileName}
                                            onError={addDefaultSrc}
                                        />
                                    ))}
                                </Carousel>
                            </div>
                        </div>
                        }
                </div>
                }

                <button className="voting-continue-btn" onClick={clickVotingContinue}>
                    <span>Continue</span>
                </button>
            </Modal>
            }

            {briefingModalIsOpen &&
            <Modal
                isOpen={briefingModalIsOpen}
                onRequestClose={closeBriefingModal}
                style={customBriefingStyles}
                shouldCloseOnOverlayClick={false}
                contentLabel="Briefing Info"
            >
                <div className="briefing-modal">
                    <div className="briefing-modal-title">Briefing</div>
                    <div className="briefing-modal-text">
                        { !isEmpty(gameScenario.briefing)
                        && <div className="briefing-scenario">
                            <h3>Scenario:</h3>
                                {gameScenario.briefing}
                            </div>
                        }
                        {(
                            !gameScenario.snippets
                            || (gameScenario.snippets.length < currentGameStatus.currentTurn)
                            || isEmpty(gameScenario.snippets.filter((snippet: ITurnBrief) => snippet.turn === currentGameStatus.currentTurn - 1))
                        )
                        && isEmpty(gameScenario.briefing)
                        && <div className="briefing-none">
                                <h3>Scenario:</h3>
                                No Briefing Available
                            </div>
                        }
                        { gameScenario.snippets
                          && (gameScenario.snippets.length >= currentGameStatus.currentTurn)
                          && !isEmpty(turnSnippet)
                          && <div className="briefing-turn">
                            <h3>Turn:</h3>
                            <div style={{marginBottom: '1em'}}>
                                {turnSnippet?.briefingText}
                            </div>
                            <div className="briefing-images">
                                <div className="snippet-carousel">
                                    {!_.isEmpty(snippetImages) && snippetImages.map((snippetImage: any, index: number) => {
                                        if (snippetImage.turn === currentGameStatus.currentTurn) {
                                            return (
                                                <Carousel
                                                    showThumbs={true}
                                                    showStatus={false}
                                                    key={index}
                                                    thumbWidth={107}
                                                >
                                                    {snippetImage.images.map((image: any, i: number) => (
                                                        <img
                                                            src={image.url !== '' ? image.url : "img/scenario1.png"}
                                                            alt="scenario"
                                                            className="scenario-carousel-img"
                                                            key={i}
                                                            onError={addDefaultSrc}
                                                        />
                                                    ))}
                                                </Carousel>
                                            );
                                        } else {
                                            return null;
                                        }
                                    })}
                                </div>
                            </div>
                        </div>
                        }
                        

                    </div>
                </div>

                <button className="delete-confirm-btn briefing-close-btn" onClick={closeBriefingModal}>Close</button>
            </Modal>
            }

            <Tooltip id="tooltip-info" className="sidemenu-tooltip" />
            <Tooltip id="tooltip-rfi" className="sidemenu-tooltip" />
            <Tooltip id="tooltip-coa" className="sidemenu-tooltip" />
            <Tooltip id="tooltip-briefs" className="sidemenu-tooltip" />
            <Tooltip id="tooltip-inject" className="sidemenu-tooltip" />
        </div>
    )
}

const customStyles = {
    content: {
      background: '#323544',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: '0',
      border: 'none',
      width: '480px',
      transform: 'translate(-50%, -50%)',
    }
};

const customVotingStyles = {
    content: {
      background: '#323544',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: '0',
      border: 'none',
      width: '620px',
      transform: 'translate(-50%, -50%)',
    }
};

const customBriefingStyles = {
    content: {
      background: '#323544',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: '0',
      border: 'none',
      width: '80vw',
      minWidth: '800px',
      transform: 'translate(-50%, -50%)',
      height: '80vh',
    }
};

const addDefaultSrc = (evt: any) => {
    evt.target.src = 'img/loading-500x258.gif'
}

export default MainGame;